export default __webpack_public_path__ + "static/media/postavshiki.d085eb8b.svg";